import importer from 'common/importer'
const Config = importer('Config')

class MenuBuilder {
    constructor(articles) {
        this.articles = articles
        this.sections = {
            aboutBiolife: [
                1,
                2,
                4,
                7,
                8,
                129
            ],
            aboutPlasma: [9, 10, 11, 12],
            becomeDonor: [
                13,
                14,
                15,
                17,
                18,
                19,
                20,
                21,
                22,
            ],
            currentDonor: [22, 23, 24, 25, 26, 27],
            legal: [49, 43, 42, 138, 139],
            dashBoard: [88, 89, 90, 91, 92, 93, 94, 128],
            centerOps: [95, 96, 97, 98, 99, 100, 123],
        }
    }

    get parsedArticles() {
        return {
            aboutBiolife: this.buildMenuSections('aboutBiolife'),
            aboutPlasma: this.buildMenuSections('aboutPlasma'),
            becomeDonor: this.buildMenuSections('becomeDonor'),
            currentDonor: this.buildMenuSections('currentDonor'),
            legal: this.buildMenuSections('legal'),
            dashBoard: this.buildMenuSections('dashBoard'),
            centerOps: this.buildMenuSections('centerOps')
        }
    }
    // to construct 'to' field it return the first section of the URL
    sectionName(sectionName, webName) {
        switch (String(sectionName)) {
            case 'aboutBiolife':
                return '/about-biolife'
            case 'aboutPlasma':
                return '/about-plasma'
            case 'becomeDonor':
                return '/become-a-donor'
            case 'currentDonor':
                return '/current-donor'
            case 'legal':
                return '/legal'
            case 'dashBoard':
                return '/dashboard'
            case 'centerOps':
                return webName === 'logout' ? '' : '/center-ops'
            default:
                return ''
        }
    }

    buildMenuSections(sectionName) {
        const sectionNames = this.sections[sectionName]
        return this.articles
            .filter(art => sectionNames.includes(art.content_id__c))
            .map(item => {
                return {
                    id: item.display_order__c,
                    name: item.section_name__c,
                    to: `${this.sectionName(sectionName, item.web_name__c)}/${item.web_name__c}`,
                    page: item.web_name__c,
                    title: item.meta_title__c,
                    metaData: item.meta_description__c
                }
            }).sort(
                (a1, a2) => (a1.id > a2.id) ? 1 : (a1.id < a2.id) ? -1 : 0
            )
    }

}

const menuItemParser = articles => {
    const menuItems = new MenuBuilder(articles)
    return menuItems.parsedArticles
}

const pageMetaArticles = {
    CONTACT_US_FORM_META: 101,
    HOME_PAGE_OG_META: 102,
    ACCOUNT_SETUP_FAILED_META: 103,
    ACCOUNT_SETUP_SUCCESS_META: 104,
    APPOINTMENT_SCHEDULING_META : 105,
    BIOLIFE_HOME_META: 106,
    CHANGE_PASSWORD_META: 107,
    CHECK_EMAIL_META :108,
    CREATE_ACCOUNT_META: 109,
    DONOR_FORGOT_PASSWORD_META: 110,
    EMAIL_CONFIRMATION_META: 111,
    EMAIL_VERIFICATOIN_META: 112,
    LOCATIONS_PAGE_META: 113,
    LOGIN_PAGE_META: 114,
    LOGIN_WITH_MEIAL_META: 115,
    N0_CENTER_PAGE_META: 116,
    REGISTER_PAGE_META: 117,
    RESET_PASSWORD_META:118,
    SIGN_IN_AUTH_META: 119,
    SOCIAL_LOGIN_META: 120,
    VERIFY_ACCOUNT_FROM_EMAIL_META: 121,
    CONTACT_US_TEXT: 8,
    NON_DISCRIMINATION_STATEMENT: 49,
    PRIVACY_TXT: 42,
    TERMS_AND_CONDITIONS: 43
}

const BASE_WEB_URL = Config.WEB_APP_URL

export default { menuItemParser, pageMetaArticles, BASE_WEB_URL }